let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");

module.exports = function(session_data, private_label_config) {

  let getSIDsAtAccessLevels = function(levels) {

    if (!_.isArray(levels)) {
      levels = [levels];
    }
    let r = esUtils.cleanup_ids(_.map(_.filter(_.pairs(session_data.permissions), function(pair) {
      return _.includes(levels, pair[1].access);
    }), 0));
    return r;
  };

  /**
   * This is a map of the access level to user classes for that level
   *
   * The user classes may be different based on privatelabel
   */
  let access_type_to_user_classes = (function() {
    let cleanupUserClassArray = function(user_classes) {
      return _.uniq(_.filter(_.flattenDeep([user_classes]), _.isString).sort());
    };
    let stringArrayOrDefault = function(arr, deflt) {
      let l = cleanupUserClassArray(arr);
      return _.isEmpty(l) ? deflt : l;
    };

    //////////////////////////////
    //here is the meat of it
    //
    //WARNING
    //  DO NOT CHANGE ANY KEYS without first doing a global search for uses of doIHaveAccess
    //  since doIHaveAccess constructs objects based on these key names
    //
    let r = {
      admin: stringArrayOrDefault(private_label_config.classes_with_admin_privs, ["ADMN", "SPKR"]),
      full: stringArrayOrDefault(private_label_config.classes_with_full_privs, ["ADMN", "SPKR", "FULL"]),
      spkr: ["SPKR"],
      read: ["READ"],
      travel: ["TRAV"]
    };
    r.view_fees = [r.admin, r.full, r.read];
    r.read_or_travel = [r.read, r.travel];
    r.limited_speaker = (private_label_config.is_privatelabel) ? [r.spkr] : [];
    //end of meat
    //////////////////////////////

    r = _.mapValues(r, cleanupUserClassArray);
    return r;
  }());

  return _.mapValues(access_type_to_user_classes, function(levels, name) {
    let level_sids = getSIDsAtAccessLevels(levels);
    let isLevelSID = _.partial(_.includes, level_sids);
    //console.log("doIHaveAccess", access_type_to_user_classes, levels, name);
    return {
      all(/* sids... */) {
        //console.log("  all", arguments);
        let sids = esUtils.cleanup_ids(_.flattenDeep(_.toArray(arguments)));
        return _.isEmpty(sids) ? false : _.every(sids, isLevelSID);
      },
      any(/* sids... */) {
        //console.log("  any", arguments);
        let sids = esUtils.cleanup_ids(_.flattenDeep(_.toArray(arguments)));
        return _.isEmpty(sids) ? false : _.some(sids, isLevelSID);
      },
      getSIDs() {
        //console.log("  getSIDs", level_sids);
        return _.cloneDeep(level_sids);//to ensure no mutating of level_sids
      }
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/doIHaveAccess.js